import React, { Component } from 'react';
import SlidingPanels from '../components/SlidingPanels';
import _ from 'lodash';
import $ from "jquery";

require('jquery.scrollto');

export default class Contact extends Component {
    get leadText() {
        const { content } = this.props;

        if (Object.keys(content).length) {
            return `${content.pages.contactUs.lead} ${content.phone}.`;
        }
        return '';
    }

    static validateEmail(email) {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    }

    static validateForm() {
        const form = document.forms[0];
        let errorCount = 0;

        if (form.honey.value === '') {
            _.each([].slice.call(form.querySelectorAll('[required]')), function (el) {
                if (el.value === '') {
                    $(el).parent('.form-group').addClass('has-error');
                    errorCount++;
                }
            });
            if (form.email.value === '' || !Contact.validateEmail(form.email.value)) {
                $(form.email).parent('.form-group').addClass('has-error');
                errorCount++;
            }
        }
        else {
            errorCount++;
        }
        return errorCount === 0;
    }

    static validateField(field) {
        let errorCount = 0;
        if (field.hasAttribute('required') && field.value === '') {
            $(field).parent('.form-group').addClass('has-error');
            errorCount++;
        }
        if (field.type === 'email' && !Contact.validateEmail(field.value)) {
            $(field).parent('.form-group').addClass('has-error');
            errorCount++;
        }
        return errorCount === 0;
    }

    validate(ev) {
        ev.preventDefault();

        if (Contact.validateForm()) {
            let submitButton = document.getElementById('btnSubmit');
            submitButton.value = "Sending...";
            document.forms[0].submit();

            submitButton.classList.add('disabled');
            submitButton.value = "Sent!";
            setTimeout(function () {
                submitButton.value = "Submit";
                submitButton.classList.remove('disabled');
            }, 10000);
        }
    }

    componentDidMount() {
        document.title = `Contact Us - C&A Assembly & Installation Solution`;

        $(window).scrollTo(30, '0.5s');
        $('input, textarea', 'form').on('focus', function () {
            $(this).parent('.form-group').removeClass('has-error');
        }).on('blur', function () {
            Contact.validateField($(this)[0]);
        });
        this.props.clearSlides();

        $.get('/data/slides/contact.json').done(data => {
            let selectedService = data[this.props.params.service || 'all'];

            for (let i = 0, len = selectedService.length; i < len; i++) {
                this.props.addSlide(selectedService[i]);
            }
        });

        setTimeout(() => {
            let selectedService = _.find(this.props.services, { class: this.props.params.service });
            if (!!selectedService) {
                this.props.selectService(selectedService);
            }
            this.setState({
                serviceTypeSelectedValue: (selectedService) ? selectedService.service : 'General Enquiry'
            });

        }, 0)
    }

    renderService = (service, i) => {
        if (service.class !== 'multilingual') {
            if (service.class === this.props.selectedService.class) {
                return <option value={service.service} selected="selected" key={i}>{service.service}</option>;
            }
            else {
                return <option value={service.service} key={i}>{service.service}</option>;
            }
        }
    }

    render() {
        const { services } = this.props;
        return (
            <div>
                <SlidingPanels {... this.props} />
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <h1>Contact Us</h1>

                            <div>{this.leadText}<br /><br /></div>

                            {/* <form action="https://getsimpleform.com/messages?form_api_token=13825b619e0a24269ea0da58e15f02f3" method="post">
                            <!-- the redirect_to is optional, the form will redirect to the referrer on submission -->
                            <input type='hidden' name='redirect_to' value='<the complete return url e.g. http://fooey.com/thank-you.html>' />
                            <!-- all your input fields here.... -->
                            <input type='text' name='test' />
                            <input type='submit' value='Test form' />
                            </form> */}
                            {/* <form id="contactForm" method="POST" action="https://formspree.io/service@cna.net.au"> */}
                            <form id="contactForm" method="POST" encType="multipart/form-data" action="https://getsimpleform.com/messages?form_api_token=8b3f6920bcf3eba4b4f9fcb715a27d03">
                                <div className="form-group">
                                    <label htmlFor="serviceType">Enquiring about</label>
                                    <select name="serviceType" id="serviceType" className="form-control" required>
                                        <option value="General Enquiry">General Enquiry</option>
                                        {services.map(this.renderService)}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">Name</label>
                                    <input type="text" className="form-control" name="name" id="name" placeholder="Name" required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone">Phone number</label>
                                    <input type="number" className="form-control" name="phone" id="phone" placeholder="Phone" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="suburb">Postcode / suburb</label>
                                    <input type="text" className="form-control" name="postcode" id="phone" placeholder="Postcode / Suburb" />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" className="form-control" name="email" id="email" placeholder="Email address" required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message">Details of the job required, eg: Product details, sizes, and any other information you think are related.</label>
                                    <textarea name="message" id="message" rows="10" className="form-control" placeholder="Your message" required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message">Attachment:</label>
                                    <input type="file" name="attachment" className="form-control" />
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <strong>
                                            (*If you need to change the confirmed working date, please notify us at least 48 hours before the actual date. Also note that any cancellation will incure a
                                            cancellation fee. For more information, please feel free to contact us to get more information.)
                                        </strong>
                                    </div>
                                </div>
                                <input type="text" name="honey" id="honey" className="hidden" />

                                <br />
                                <input id="btnSubmit" name="btnSubmit" type="submit" value="Submit" className="btn btn-default" onClick={this.validate} />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Contact.js